"use strict";

exports.__esModule = true;
exports.default = findKey;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _keys2 = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Returns the first key on an object that passes a truth test.
function findKey(obj, predicate, context) {
  predicate = (0, _cb.default)(predicate, context);
  var _keys = (0, _keys2.default)(obj),
    key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}